export default class Reference {
	dosageStrength: number | null;

	packageSize: number | null;

	referenceBasketVersion: string;

	referencedProductType: string;

	historicProductDataViewDate: Date | null;

	constructor(
		dosageStrength: number | null,
		packageSize: number | null,
		referenceBasketVersion: string,
		referencedProductType: string,
		historicProductDataViewDate: Date | null
	) {
		this.dosageStrength = dosageStrength;
		this.packageSize = packageSize;
		this.referenceBasketVersion = referenceBasketVersion;
		this.referencedProductType = referencedProductType;
		this.historicProductDataViewDate = historicProductDataViewDate;
	}
}
